import type { PayloadAction } from '@reduxjs/toolkit';
import { upsertIssue as upsertIssueState } from '@ui/features/quote-builder/state/utilities/issue-managers';
import type { IssueInsertType } from '@ui/features/quote-builder/types/state/issues';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

/**
 * Action for upserting issues in the QuoteBuilderState. Useful for adding
 * issues from thunks (that must dispatch actions and cannot edit a
 * `WritableDraft` directly using the `upsertIssue` utility function).
 */
export function upsertIssue(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{
    issueId: string;
    issue: IssueInsertType;
  }>,
) {
  upsertIssueState(state, action.payload.issueId, action.payload.issue);
}
